<template>
  <CustomMarker
    :class="`custom-marker ${isSelectedOrHighlighted ? 'highlighted' : ''} ${license.latlng ? '' : 'd-none'}`"
    :options="options"
    :style="`opacity:1;z-index:99;`"
    @click.stop="click"
    @mouseover.stop="highlight"
    @mouseout.stop="unhighlight"
  >
    <CustomMarkerIcon
      :icon-name="iconName"
      :color="color"
    />
  </CustomMarker>
</template>

<script>
import {CustomMarker} from "vue3-google-map";
import CustomMarkerIcon from "@/components/common/CustomMarkerIcon.vue";
import {License} from "@/models/License";

export default {
  components: {
    CustomMarker,
    CustomMarkerIcon
  },
  props: {
    license: License,
    selectedId: String
  },
  computed: {
    options() {
      return {
        title: this.license.addressFormatted,
        position: this.license.latlng,
        optimized: true
      };
    },
    isSelectedOrHighlighted() {
      return this.selected || this.$ui.isHighlighted(this.license.id);
    },
    selected() {
      return this.selectedId === this.license.id;
    },
    config() {
      const status = this.license.statusWithConfig;
      if (status) {
        switch (status.type) {
          case 'active':
            return {
              color: '33A852'
            };
          case 'inactive':
            return {
              color: '6c757d'
            };
          case 'pending':
            return {
              color: 'ea4345'
            };
        }
      }
      return {
        color: '6c757d'
      };
    },
    iconName() {
      return this.config.icon;
    },
    color() {
      return this.config.color;
    }
  },
  methods: {
    click() {
      const route = {
        name: 'license-detail',
        params: {selectedLicenseId: this.license.id}
      };
      if (this.$route.name === 'licenses' || this.$route.name === 'license-detail') {
        route.query = this.$route.query;
      }
      this.$router.push(route);
    },
    highlight() {
      this.$ui.setHighlighted(this.license.id, 'map');
    },
    unhighlight() {
      this.$ui.clearHighlighted('map');
    }
  }
}
</script>

<style>
.custom-marker {
  z-index: 1;
  transition: z-index 0ms linear 250ms;
}
.custom-marker>.custom-marker-icon {
  transition: scale 250ms;
}
.custom-marker.highlighted {
  z-index: 100!important;
}
.custom-marker.highlighted>.custom-marker-icon {
  scale: 2;
}
</style>
